import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CouponType, DiscountRejectionCouponExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { RuleOperator } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { ConfigurationFormGroup } from '../../../model';
import {
  couponRuleRadioOptions,
  replacementRuleRadioOptions,
  couponTypeOptions,
  combinesWithCheckboxes,
  allFormatsDisabled,
  dynamicFieldsMentionConfig,
} from '../../../discount-rejection-coupon.config';

@Component({
  selector: 'discount-rejection-coupon-configuration',
  templateUrl: './discount-rejection-coupon-configuration.component.html',
  styleUrls: ['./discount-rejection-coupon-configuration.component.scss'],
  standalone: false,
})
export class DiscountRejectionCouponConfigurationComponent {
  @Input() configurationsFormArray: FormArray<FormGroup<ConfigurationFormGroup>>;
  @Input() storeDiscountOptions: { value: string; label: string }[] = [];
  @Input() shopCurrencySymbol: string;

  @Output() onAddConfiguration = new EventEmitter<void>();
  @Output() onRemoveConfiguration = new EventEmitter<number>();
  @Output() onDuplicateConfiguration = new EventEmitter<number>();
  @Output() onSearchDiscount = new EventEmitter<string>();
  CouponRule = RuleOperator;
  ReplacementRule = DiscountRejectionCouponExtension.ReplacementRule;
  couponRuleRadioOptions = couponRuleRadioOptions;
  replacementRuleRadioOptions = replacementRuleRadioOptions;
  couponTypeOptions = couponTypeOptions;
  combinesWithCheckboxes = combinesWithCheckboxes;
  CouponType = CouponType;
  dynamicFieldsMentionConfig = dynamicFieldsMentionConfig;
  allFormatsDisabled = allFormatsDisabled;

  get configurations() {
    return this.configurationsFormArray?.controls ?? [];
  }

  get hasAllCouponCodesRule(): boolean {
    return this.configurations.some((control) => control.get('couponRule')?.value === RuleOperator.IS_ALL);
  }

  get canAddMoreRules(): boolean {
    return !this.hasAllCouponCodesRule;
  }

  get shouldDisableAllCouponCodes(): boolean {
    return this.configurationsFormArray?.length > 1;
  }

  getDiscountValueMax(configForm: FormGroup<ConfigurationFormGroup>): number {
    return configForm.get('couponType')?.value === CouponType.PERCENTAGE ? 100 : 999999;
  }
}
